export function showPageWrapper(animationDuration) {
  const el = document.querySelector('div#page');
  if (!el) {
    return false;
  }
  el.classList.add('overlay--leaving');
  document.body.style.overflow = 'auto';

  setTimeout(() => {
    el.classList.remove('overlay');
    el.classList.remove('overlay--leaving');
  }, animationDuration);

  return true;
}

export function hidePageWrapper() {
  const el = document.querySelector('div#page');
  if (!el) {
    return false;
  }

  el.classList.add('overlay');
  document.body.style.overflow = 'hidden';
  return true;
}
